import actions from "./actions";
import getters from "./getters";
import state from "./state";

export default {
  namespaced: true,
  getters,
  state,
  actions,
};
